module.exports = __webpack_public_path__ + "img/46.9.TU.b96c2905.png";